





























































































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import AppDialog from '@/components/AppDialog.vue'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppTableDate from '@/components/AppTableDate.vue'
import AppSearch from '@/components/AppSearch.vue'
import FilterTextSearch from '@/components/FilterTextSearch.vue'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { policyStatus, policyStatusClass } from '@/modules/Policy/helpers/policy'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import SearchAccount from '@/mixins/search-queries/search-account'
import SearchCarrier from '@/mixins/search-queries/search-carrier'
import SearchCarrierProduct from '@/mixins/search-queries/search-carrier-product'
import { Account } from '@/modules/Account/interfaces/account'
import { Carrier } from '@/modules/Carrier/interfaces/carrier'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import PoliciesDialogTab from './policies-dialog-tab.vue'
import { DailyStat } from '../interfaces/daily-stat.interface'

@Component({
  components: {
    AppDialog,
    AppBreadcrumbs,
    AppTableDate,
    AppSearch,
    FilterTextSearch,
    PoliciesDialogTab
  }
})
export default class CalendarDailyDialog extends mixins(SearchAccount, SearchCarrier, SearchCarrierProduct) {
  @Prop({ type: Boolean }) readonly show!: boolean
  @Prop({ type: String }) readonly title!: string
  @Prop({ type: Array }) readonly policies!: Policy[]
  @Prop({ type: Object as () => DailyStat }) readonly stat!: DailyStat
  @Prop({ type: Boolean, default: false }) readonly showTab!: boolean
  @Prop({ type: Number }) readonly tabIndex!: number

  policyStatus = policyStatus
  policyStatusClass = policyStatusClass
  showDialog = false

  tabActive = 0
  loading = false

  policyTableColumn = [
    { field: 'policyNumber',
      title: 'Policy Number',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.policyNumber ? row.policyNumber : '-')
        ]
      }
      },
      sortable: true,
      resizable: true
    },
    { field: 'policyName',
      title: 'Policy Name',
      slots: { default: 'name_default' },
      resizable: true,
      sortable: true
    },
    {
      field: 'status',
      title: 'Status',
      slots: { default: 'status_default' },
      sortable: true,
      resizable: true,
      width: 150
    },
    { title: 'Client',
      field: 'account',
      slots: { default: 'account_default' },
      resizable: true
    },
    { title: 'Carrier',
      field: 'carrier',
      slots: { default: 'carrier_name_default' },
      resizable: true
    },
    { title: 'Insurance Product',
      field: 'carrierProduct',
      slots: {
        default: 'product_default'
      },
      resizable: true
    },
    { title: 'Effective Date',
      field: 'effectiveDate',
      slots: {
        default: 'effective_default'
      },
      resizable: true,
      sortable: true,
      width: 120
    },
    { title: 'Expiration Date',
      field: 'expirationDate',
      slots: {
        default: 'expiration_default'
      },
      sortable: true,
      width: 120
    }
  ]

  filter = {
    accountName: '',
    carrierName: '',
    carrierProductName: '',
    policyNumber: ''
  }

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  candidatesPolicyNumber: string[] = []

  filteredPolicies: Policy[] = []

  allAccounts: Account[] = []
  allCarriers: Carrier[] = []
  allCarrierProducts: CarrierProduct[] = []
  accountsMap: { [key: string]: Account } = {}
  carriersMap: { [key: string]: Carrier } = {}
  productsMap: { [key: string]: CarrierProduct } = {}
  allPolicyNumbers: string[] = []

  get policiesPerPage () {
    const { tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const offset = (currentPage - 1) * pageSize
    return this.$R.slice(offset, pageSize + offset, this.filteredPolicies)
  }

  @Watch('tabActive')
  async onTabActiveChanged () {
    this.handleChangeTab()
  }

  @Watch('show')
  async onShowChanged (val: boolean) {
    this.showDialog = val
  }

  @Watch('tabIndex')
  onTabIndexChanged (val: number) {
    this.tabActive = val
  }

  @Watch('policies')
  onPoliciesChanged (val: Policy[]) {
    this.loading = false
    this.tableOptions.loading = false
    this.tableOptions.tablePage.total = val.length
    this.tableOptions.tablePage.currentPage = 1
    this.filteredPolicies = val

    this.filter = {
      accountName: '',
      policyNumber: '',
      carrierName: '',
      carrierProductName: ''
    }

    this.allAccounts = []
    this.allCarriers = []
    this.allCarrierProducts = []
    this.allPolicyNumbers = []

    for (const policy of this.policies) {
      if (policy.account) {
        this.accountsMap[`${policy.account.id}-${policy.account.name}`] = policy.account
      }

      if (policy.carrier) {
        this.carriersMap[`${policy.carrier.id}-${policy.carrier.name}`] = policy.carrier
      }

      if (policy.carrierProduct) {
        this.productsMap[`${policy.carrierProduct.id}-${policy.carrierProduct.name}`] = policy.carrierProduct
      }

      if (policy.policyNumber) {
        this.allPolicyNumbers.push(policy.policyNumber)
      }
    }

    this.candidatesAccount = this.$R.values(this.accountsMap)
    this.candidatesCarrier = this.$R.values(this.carriersMap)
    this.candidatesCarrierProduct = this.$R.values(this.productsMap)
    this.candidatesPolicyNumber = Array.from(new Set(this.allPolicyNumbers))
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.filterPolicies()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
  }

  filterAccounts (query: string) {
    const { accountsMap } = this

    this.candidatesAccount = this.$R.values(accountsMap).filter((account: Account) => {
      return account.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    })
  }

  filterCarriers (query: string) {
    const { carriersMap } = this

    this.candidatesCarrier = this.$R.values(carriersMap).filter((carrier: Carrier) => {
      return carrier.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    })
  }

  filterCarrierProducts (query: string) {
    const { productsMap } = this

    this.candidatesCarrierProduct = this.$R.values(productsMap).filter((carrierProduct: CarrierProduct) => {
      return carrierProduct.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    })
  }

  filterPolicyNumber (query: string) {
    const {
      allPolicyNumbers
    } = this

    this.candidatesPolicyNumber = allPolicyNumbers.filter(policyNumber => {
      return policyNumber.toLowerCase().indexOf(query.toLowerCase()) !== -1
    })
  }

  filterPolicies () {
    const { policies } = this
    const {
      accountName, carrierName, carrierProductName, policyNumber
    } = this.filter
    const { sortBy, sortDesc } = this.tableOptions

    let filteredPolicies = [...policies]

    if (accountName) {
      filteredPolicies = filteredPolicies.filter(policy => {
        return policy.account && policy.account.name.toLowerCase().indexOf(accountName.toLowerCase()) !== -1
      })
    }

    if (carrierName) {
      filteredPolicies = filteredPolicies.filter(policy => {
        return policy.carrier && policy.carrier.name.toLowerCase().indexOf(carrierName.toLowerCase()) !== -1
      })
    }

    if (carrierProductName) {
      filteredPolicies = filteredPolicies.filter(policy => {
        return policy.carrierProduct && policy.carrierProduct.name.toLowerCase().indexOf(carrierProductName.toLowerCase()) !== -1
      })
    }

    if (policyNumber) {
      filteredPolicies = filteredPolicies.filter(policy => {
        return policy.policyNumber && policy.policyNumber.toLowerCase().indexOf(policyNumber.toLowerCase()) !== -1
      })
    }

    this.filteredPolicies = sortDesc
      ? this.$R.sortWith([this.$R.descend(this.$R.prop(sortBy))])(filteredPolicies)
      : this.$R.sortWith([this.$R.ascend(this.$R.prop(sortBy))])(filteredPolicies)

    this.tableOptions.tablePage.total = filteredPolicies.length
  }

  @Emit('cancel')
  handleCancel () {
    // do nothing
  }

  @Emit('changeTab')
  handleChangeTab () {
    this.loading = true
    return this.tabActive
  }

  routeTo (name: string, params: any) {
    this.$router.push({
      name,
      params
    })
  }

  routeToDetail (item: any) {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: item.id
      }
    }
  }

  routeToCarrierDetail (item: any) {
    if (item.carrier) {
      return {
        name: 'CarrierDetailDetail',
        params: {
          id: item.carrier.id
        }
      }
    }
  }

  routeToAccountDetail (item: any) {
    if (item.account) {
      return {
        name: 'AccountDetailDetail',
        params: {
          id: item.account.id
        }
      }
    }
  }

  routeToCarrierProductDetail (item: any) {
    if (item.carrierProduct) {
      return {
        name: 'CarrierProductDetailDetail',
        params: {
          id: item.carrierProduct.id
        }
      }
    }
  }
}
